import { Button } from '@design/components/button/Button';
import { Icon } from '@design/components/icon/Icon';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { useOnboardingStore } from '../hooks/useOnboardingStore';
import styles from './AlertMessage.module.scss';

export interface AlertMessageProps {
  tableRef: React.RefObject<HTMLTableRowElement | null>;
  alertMessage: {
    message: string;
    isError?: boolean;
  };
  insideModal?: boolean;
  isEntitiesOverflowing: boolean;
  clearMessage: () => void;
}

/**
 * @deprecated
 */
export const AlertMessage = ({
  tableRef,
  alertMessage,
  insideModal,
  isEntitiesOverflowing,
  clearMessage,
}: AlertMessageProps) => {
  const { t } = useTranslation(['watchlistManager']);
  const { resolvedEntityData } = useOnboardingStore(state => ({
    resolvedEntityData: state.resolvedEntityData,
  }));

  const onClickViewUnmapped = () => {
    tableRef.current?.scrollIntoView({ behavior: 'smooth', block: 'center' });
  };

  if (!alertMessage.message) {
    return null;
  }

  const currentUnMappedEntities = resolvedEntityData.entities.filter(
    e => !e.primaryEntity.tag
  );

  return (
    <div
      className={styles.alertContainer}
      {...(alertMessage.isError ? { 'data-error': true } : {})}
      style={{
        top: insideModal ? '50px' : '-74px',
        width: insideModal ? 'calc(100% - 40px)' : '640px',
      }}
    >
      <div className={styles.messageWrapper}>
        <Icon
          size={20}
          iconName="InformationCircle"
          fillColor={
            alertMessage.isError
              ? 'var(--icon-critical)'
              : 'var(--icon-primary)'
          }
        />
        <div className={styles.alertDescription}>{alertMessage.message}</div>
        <button className={styles.close} onClick={clearMessage}>
          <Icon iconName="Close" size={14} />
        </button>
      </div>
      {!!currentUnMappedEntities.length && isEntitiesOverflowing && (
        <Button
          className={styles.styledViewUnMapped}
          variant="secondary"
          size="small"
          label={t('watchlistManager:alertMessage.viewUnmapped')}
          onClick={onClickViewUnmapped}
        />
      )}
    </div>
  );
};
